import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TemplateModel } from '@fi-app/template/template.model';
import { StateSrefLinkDirective } from '@fi-shared/fi-state-proxy/state-sref/state-sref-link.directive';
import { TemplateLayoutService } from '@fi-app/template/template-layout.service';
import { TemplateLayoutModel } from '@fi-app/template/template-layout.model';
import { DocumentControlContentLanguageLabelModel } from '@fi-app/document/document-control-content-language-label.model';
import { DocumentModel } from '@fi-app/document/document.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-document-version',
    templateUrl: './document-version.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./document-version.component.scss'],
    standalone: false,
})
export class DocumentVersionComponent implements OnInit {
    @Input('document') Document: DocumentModel;
    @Input('activeVersion') ActiveVersion;
    @Input('selectedVersion') SelectedVersion;
    @Input() templateResponse: TemplateModel;
    @Input('selectedVersionDocumentControlContents')
    SelectedVersionDocumentControlContents: DocumentControlContentLanguageLabelModel[];
    @Input('activeVersionDocumentControlContents')
    ActiveVersionDocumentControlContents: DocumentControlContentLanguageLabelModel[];

    @ViewChild('restoreBtnStateSref', { static: false }) restoreBtnStateSref: StateSrefLinkDirective;

    SelectedVersionTemplateLayout: TemplateLayoutModel;
    ActiveVersionTemplateLayout: TemplateLayoutModel;
    FiStateNames = FiStateNames;

    constructor(
        private fiDialogsService: FiDialogsService,
        private templateLayoutService: TemplateLayoutService,
        private appTextService: AppTextService,
        private stateService: FiStateService,
        private injector: Injector,
    ) {}

    ngOnInit() {
        const SelectedVersionTemplate = this.templateResponse;
        this.SelectedVersionTemplateLayout = this.templateLayoutService.GetLayout(
            SelectedVersionTemplate,
            this.Document,
        );
        this.templateLayoutService.ApplyDocumentControlContentsToTemplate(
            this.SelectedVersionDocumentControlContents,
            SelectedVersionTemplate,
        );
        this.templateLayoutService.TemplatePlaceHolderCollectionToLayout(
            SelectedVersionTemplate.PlaceHolderCollection,
            this.SelectedVersionTemplateLayout,
        );

        const ActiveVersionTemplate = new TemplateModel(
            JSON.parse(JSON.stringify(this.Document.Template)),
            this.injector,
        );
        this.ActiveVersionTemplateLayout = this.templateLayoutService.GetLayout(ActiveVersionTemplate, this.Document);
        this.templateLayoutService.ApplyDocumentControlContentsToTemplate(
            this.ActiveVersionDocumentControlContents,
            ActiveVersionTemplate,
        );
        this.templateLayoutService.TemplatePlaceHolderCollectionToLayout(
            ActiveVersionTemplate.PlaceHolderCollection,
            this.ActiveVersionTemplateLayout,
        );
    }

    getDocumentId() {
        return this.stateService.params.DocumentId;
    }

    getCompareVersion() {
        return this.SelectedVersion.DocumentVersion;
    }

    getLanguageId() {
        return this.stateService.params.languageId;
    }

    restoreClick($event: Event) {
        $event.preventDefault();
        this.fiDialogsService
            .confirm({
                headerText: this.appTextService.get('document_version.restore_confirm_header'),
                messageText: this.appTextService.get('document_version.restore_confirm'),
            })
            .onYesButtonClick(() => {
                this.restoreBtnStateSref.navigate({ location: 'replace' });
            });
    }
}
